import React from "react";
import  { useState, useEffect } from 'react';
import './classes/AllScouts.css';
import { Link, useNavigate,useParams,useLocation } from 'react-router-dom';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import SalespersonSidebar from "./SalespersonSidebar";

const AllScouts = () => {

    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const {slug} = useParams();

    const [activeScouts, setActiveScouts] = useState([]);
    //   useEffect(() => {
    //             Promise.all([
                    
    //             ])
    //             .then(() => {
             
    //             setIsLoading(false);
    //             })
             
    //         },[]);

        //pagination
        const [currentPage, setCurrentPage] = useState(1);
        // const [page, setPage] = useState(1);
        const [itemsPerPage, setItemsPerPage] = useState(50);

        const [totalItems, setTotalItems] = useState(0);
        const totalPages = Math.ceil(totalItems / itemsPerPage);

    const startIndex = (currentPage - 1) * itemsPerPage;
    const lastPageIndex = Math.min(startIndex + itemsPerPage, totalItems);
    
            // const startIndex =
            //     (currentPage - 1) * itemsPerPage;
            // const endIndex =
            //     startIndex + itemsPerPage;
            // const currentItems =
            //     activeScouts.slice(startIndex, endIndex);
    
        // function goToNextPage() {
        //     setCurrentPage(prevPage => prevPage + 1);
        // }
        function goToNextPage() {
            setCurrentPage(prev => Math.min(prev + 1, totalPages));
        }
    
        function goToPrevPage() {
            setCurrentPage(prevPage => prevPage - 1);
        }
    
        function goToSpecificPage(pageNumber) {
            setCurrentPage(pageNumber);
        }
        function renderPaginationControls() {
            // const totalPages = Math.ceil(activeScouts.length / itemsPerPage);

            const goToFirstPage = () => setCurrentPage(1);
            const goToLastPage = () => setCurrentPage(totalPages);

            const maxButtons = 10;
            let startPage = Math.max(1, currentPage - Math.floor(maxButtons / 2));
            // let endPage = startPage + maxButtons - 1;
            let endPage = Math.min(totalPages, startPage + maxButtons - 1);

            if (endPage > totalPages) {
                endPage = totalPages;
                startPage = Math.max(1, endPage - maxButtons + 1);
            }

            const pageNumbers = [];
            for (let i = startPage; i <= endPage; i++) {
                pageNumbers.push(i);
            }

            return (
                <div>
                    {/* {activeScouts.length > itemsPerPage && ( */}
                    {totalItems > itemsPerPage && (
                        <div style={{ textAlign: "center" }} className="all-scout-list-pagination">

                            {/* First + Prev */}
                            {currentPage !== 1 && (
                                <>
                                    <button onClick={goToFirstPage}>« First</button>
                                    <button onClick={goToPrevPage}>‹ Previous</button>
                                </>
                            )}
                            {pageNumbers.map((num) => (
                                <button
                                    key={num}
                                    onClick={() => goToSpecificPage(num)}
                                    style={{
                                        fontWeight: num === currentPage ? "bold" : "normal",
                                        color: num === currentPage ? "#111" : "#2c99d2",
                                    }}
                                >
                                    {num}
                                </button>
                            ))}

                            {/* Next + Last */}
                            {currentPage !== totalPages && (
                                <>
                                    <button onClick={goToNextPage}>Next ›</button>
                                    <button onClick={goToLastPage}>Last »</button>
                                </>
                            )}
                        </div>
                    )}
                </div>
            );
        }
        // const lastPageIndex = Math.min(activeScouts.length, endIndex);

    React.useEffect(() => {
         const fetchData = async () => {
            // Simulate API call to your server
            // In a real application, replace this with your actual fetch logic
            try {
               setIsLoading(true);
            const response = await fetch(app_url+'smwwscout/getallscoutlist', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                page: currentPage,
                pagesize: itemsPerPage,
            // id:continentid
              }),
            });
            const data = await response.json();
            setActiveScouts(data.data.result);
            setTotalItems(Number(data.data.rowCount));
          }  catch (error) {
                  console.error('Error fetching data:', error);
                } finally {
                  setIsLoading(false); // Set loading to false after fetch completes (success or error)
                }
          };
      
          fetchData();
         
        }, [currentPage]); // Re-fetch data when these change

    return (
        <>      
        {isLoading ? (
            <Loading />
        ) : ( 
            <div id="main">
                <Helmet><title>All Scouts</title></Helmet>
                <div className="left"></div>
                <div className="center left-center">
                    <div className="all-scout-container">
                        <div>
                            <h1>Scouts</h1>
                            <div className="view-header">
                                {/* Displaying {activeScouts ? (startIndex+1) : (0)} - {activeScouts ? (lastPageIndex) : (0)} of {activeScouts ? (activeScouts.length) : (0)} */}
                                Displaying {totalItems === 0 ? 0 : startIndex + 1} - {lastPageIndex} of {totalItems}
                            </div>
                            <div className="all-scout-list-container">
                                <ul>
                                    {activeScouts.map((scout, index) => (
                                    <li key={index}>  
                                        <div className="">
                                            <a href={scout.url}  target="_blank" rel="noreferrer">
                                                {((scout.image === '') || !scout.image )? (
                                                    <img
                                                        src='/basic/web/images/notavailable.jpg'
                                                        alt={scout.name}
                                                        style={{maxWidth: "100px", maxHeight: "100px"}}
                                                    />
                                                ) : (
                                                    <img
                                                        src={scout.image}
                                                        alt={scout.name}
                                                        style={{maxWidth: "100px", maxHeight: "100px"}}
                                                    />
                                                )}
                                            </a>
                                        </div> 
                                        <div className="">
                                            <a href={scout.url}  target="_blank" rel="noreferrer">{scout.name}</a>
                                        </div>
                                        <div className="">
                                            <div className="">{scout.sport}</div>  
                                        </div>
                                        <div className="">
                                            <div className="">{scout.address}</div>
                                        </div>
                                    </li>
                                    ))}
                                </ul>
                            </div>
                            <div style={{clear: "both"}}></div>
                            {renderPaginationControls()}
                        </div>
                    </div>
                </div>
                <div className="right">
                     {/* {
                        (userLoggedInRoles.includes(configData.ROLE_ADMINISTRATOR) ||
                        userLoggedInRoles.includes(configData.ROLE_SAADMIN) ||
                        userLoggedInRoles.includes(configData.ROLE_SALES_PEOPLE))
                            &&  */}
                            <SalespersonSidebar /> 
                        {/* }  */}
                </div>
            </div>
        )}
        </>
    );
};
export default AllScouts;